
export const COUNTRY_CODE = {
    INDONESIA: 'ID',
} as const

export const INDONESIA_PHONE_EXT = '62';

export const COUNTRY_EXT = [
    {
        "code": "BD",
        "country": "Bangladesh",
        "ext": "880"
    },
    {
        "code": "BE",
        "country": "Belgium",
        "ext": "32"
    },
    {
        "code": "BF",
        "country": "Burkina Faso",
        "ext": "226"
    },
    {
        "code": "BG",
        "country": "Bulgaria",
        "ext": "359"
    },
    {
        "code": "BA",
        "country": "Bosnia and Herzegovina",
        "ext": "387"
    },
    {
        "code": "BB",
        "country": "Barbados",
        "ext": "+1-246"
    },
    {
        "code": "WF",
        "country": "Wallis and Futuna",
        "ext": "681"
    },
    {
        "code": "BL",
        "country": "Saint Barthelemy",
        "ext": "590"
    },
    {
        "code": "BM",
        "country": "Bermuda",
        "ext": "+1-441"
    },
    {
        "code": "BN",
        "country": "Brunei",
        "ext": "673"
    },
    {
        "code": "BO",
        "country": "Bolivia",
        "ext": "591"
    },
    {
        "code": "BH",
        "country": "Bahrain",
        "ext": "973"
    },
    {
        "code": "BI",
        "country": "Burundi",
        "ext": "257"
    },
    {
        "code": "BJ",
        "country": "Benin",
        "ext": "229"
    },
    {
        "code": "BT",
        "country": "Bhutan",
        "ext": "975"
    },
    {
        "code": "JM",
        "country": "Jamaica",
        "ext": "+1-876"
    },
    {
        "code": "BV",
        "country": "Bouvet Island",
        "ext": ""
    },
    {
        "code": "BW",
        "country": "Botswana",
        "ext": "267"
    },
    {
        "code": "WS",
        "country": "Samoa",
        "ext": "685"
    },
    {
        "code": "BQ",
        "country": "Bonaire, Saint Eustatius and Saba ",
        "ext": "599"
    },
    {
        "code": "BR",
        "country": "Brazil",
        "ext": "55"
    },
    {
        "code": "BS",
        "country": "Bahamas",
        "ext": "+1-242"
    },
    {
        "code": "JE",
        "country": "Jersey",
        "ext": "+44-1534"
    },
    {
        "code": "BY",
        "country": "Belarus",
        "ext": "375"
    },
    {
        "code": "BZ",
        "country": "Belize",
        "ext": "501"
    },
    {
        "code": "RU",
        "country": "Russia",
        "ext": "7"
    },
    {
        "code": "RW",
        "country": "Rwanda",
        "ext": "250"
    },
    {
        "code": "RS",
        "country": "Serbia",
        "ext": "381"
    },
    {
        "code": "TL",
        "country": "East Timor",
        "ext": "670"
    },
    {
        "code": "RE",
        "country": "Reunion",
        "ext": "262"
    },
    {
        "code": "TM",
        "country": "Turkmenistan",
        "ext": "993"
    },
    {
        "code": "TJ",
        "country": "Tajikistan",
        "ext": "992"
    },
    {
        "code": "RO",
        "country": "Romania",
        "ext": "40"
    },
    {
        "code": "TK",
        "country": "Tokelau",
        "ext": "690"
    },
    {
        "code": "GW",
        "country": "Guinea-Bissau",
        "ext": "245"
    },
    {
        "code": "GU",
        "country": "Guam",
        "ext": "+1-671"
    },
    {
        "code": "GT",
        "country": "Guatemala",
        "ext": "502"
    },
    {
        "code": "GS",
        "country": "South Georgia and the South Sandwich Islands",
        "ext": ""
    },
    {
        "code": "GR",
        "country": "Greece",
        "ext": "30"
    },
    {
        "code": "GQ",
        "country": "Equatorial Guinea",
        "ext": "240"
    },
    {
        "code": "GP",
        "country": "Guadeloupe",
        "ext": "590"
    },
    {
        "code": "JP",
        "country": "Japan",
        "ext": "81"
    },
    {
        "code": "GY",
        "country": "Guyana",
        "ext": "592"
    },
    {
        "code": "GG",
        "country": "Guernsey",
        "ext": "+44-1481"
    },
    {
        "code": "GF",
        "country": "French Guiana",
        "ext": "594"
    },
    {
        "code": "GE",
        "country": "Georgia",
        "ext": "995"
    },
    {
        "code": "GD",
        "country": "Grenada",
        "ext": "+1-473"
    },
    {
        "code": "GB",
        "country": "United Kingdom",
        "ext": "44"
    },
    {
        "code": "GA",
        "country": "Gabon",
        "ext": "241"
    },
    {
        "code": "SV",
        "country": "El Salvador",
        "ext": "503"
    },
    {
        "code": "GN",
        "country": "Guinea",
        "ext": "224"
    },
    {
        "code": "GM",
        "country": "Gambia",
        "ext": "220"
    },
    {
        "code": "GL",
        "country": "Greenland",
        "ext": "299"
    },
    {
        "code": "GI",
        "country": "Gibraltar",
        "ext": "350"
    },
    {
        "code": "GH",
        "country": "Ghana",
        "ext": "233"
    },
    {
        "code": "OM",
        "country": "Oman",
        "ext": "968"
    },
    {
        "code": "TN",
        "country": "Tunisia",
        "ext": "216"
    },
    {
        "code": "JO",
        "country": "Jordan",
        "ext": "962"
    },
    {
        "code": "HR",
        "country": "Croatia",
        "ext": "385"
    },
    {
        "code": "HT",
        "country": "Haiti",
        "ext": "509"
    },
    {
        "code": "HU",
        "country": "Hungary",
        "ext": "36"
    },
    {
        "code": "HK",
        "country": "Hong Kong",
        "ext": "852"
    },
    {
        "code": "HN",
        "country": "Honduras",
        "ext": "504"
    },
    {
        "code": "HM",
        "country": "Heard Island and McDonald Islands",
        "ext": " "
    },
    {
        "code": "VE",
        "country": "Venezuela",
        "ext": "58"
    },
    {
        "code": "PR",
        "country": "Puerto Rico",
        "ext": "+1-787 and 1-939"
    },
    {
        "code": "PS",
        "country": "Palestinian Territory",
        "ext": "970"
    },
    {
        "code": "PW",
        "country": "Palau",
        "ext": "680"
    },
    {
        "code": "PT",
        "country": "Portugal",
        "ext": "351"
    },
    {
        "code": "SJ",
        "country": "Svalbard and Jan Mayen",
        "ext": "47"
    },
    {
        "code": "PY",
        "country": "Paraguay",
        "ext": "595"
    },
    {
        "code": "IQ",
        "country": "Iraq",
        "ext": "964"
    },
    {
        "code": "PA",
        "country": "Panama",
        "ext": "507"
    },
    {
        "code": "PF",
        "country": "French Polynesia",
        "ext": "689"
    },
    {
        "code": "PG",
        "country": "Papua New Guinea",
        "ext": "675"
    },
    {
        "code": "PE",
        "country": "Peru",
        "ext": "51"
    },
    {
        "code": "PK",
        "country": "Pakistan",
        "ext": "92"
    },
    {
        "code": "PH",
        "country": "Philippines",
        "ext": "63"
    },
    {
        "code": "PN",
        "country": "Pitcairn",
        "ext": "870"
    },
    {
        "code": "PL",
        "country": "Poland",
        "ext": "48"
    },
    {
        "code": "PM",
        "country": "Saint Pierre and Miquelon",
        "ext": "508"
    },
    {
        "code": "ZM",
        "country": "Zambia",
        "ext": "260"
    },
    {
        "code": "EH",
        "country": "Western Sahara",
        "ext": "212"
    },
    {
        "code": "EE",
        "country": "Estonia",
        "ext": "372"
    },
    {
        "code": "EG",
        "country": "Egypt",
        "ext": "20"
    },
    {
        "code": "ZA",
        "country": "South Africa",
        "ext": "27"
    },
    {
        "code": "EC",
        "country": "Ecuador",
        "ext": "593"
    },
    {
        "code": "IT",
        "country": "Italy",
        "ext": "39"
    },
    {
        "code": "VN",
        "country": "Vietnam",
        "ext": "84"
    },
    {
        "code": "SB",
        "country": "Solomon Islands",
        "ext": "677"
    },
    {
        "code": "ET",
        "country": "Ethiopia",
        "ext": "251"
    },
    {
        "code": "SO",
        "country": "Somalia",
        "ext": "252"
    },
    {
        "code": "ZW",
        "country": "Zimbabwe",
        "ext": "263"
    },
    {
        "code": "SA",
        "country": "Saudi Arabia",
        "ext": "966"
    },
    {
        "code": "ES",
        "country": "Spain",
        "ext": "34"
    },
    {
        "code": "ER",
        "country": "Eritrea",
        "ext": "291"
    },
    {
        "code": "ME",
        "country": "Montenegro",
        "ext": "382"
    },
    {
        "code": "MD",
        "country": "Moldova",
        "ext": "373"
    },
    {
        "code": "MG",
        "country": "Madagascar",
        "ext": "261"
    },
    {
        "code": "MF",
        "country": "Saint Martin",
        "ext": "590"
    },
    {
        "code": "MA",
        "country": "Morocco",
        "ext": "212"
    },
    {
        "code": "MC",
        "country": "Monaco",
        "ext": "377"
    },
    {
        "code": "UZ",
        "country": "Uzbekistan",
        "ext": "998"
    },
    {
        "code": "MM",
        "country": "Myanmar",
        "ext": "95"
    },
    {
        "code": "ML",
        "country": "Mali",
        "ext": "223"
    },
    {
        "code": "MO",
        "country": "Macao",
        "ext": "853"
    },
    {
        "code": "MN",
        "country": "Mongolia",
        "ext": "976"
    },
    {
        "code": "MH",
        "country": "Marshall Islands",
        "ext": "692"
    },
    {
        "code": "MK",
        "country": "Macedonia",
        "ext": "389"
    },
    {
        "code": "MU",
        "country": "Mauritius",
        "ext": "230"
    },
    {
        "code": "MT",
        "country": "Malta",
        "ext": "356"
    },
    {
        "code": "MW",
        "country": "Malawi",
        "ext": "265"
    },
    {
        "code": "MV",
        "country": "Maldives",
        "ext": "960"
    },
    {
        "code": "MQ",
        "country": "Martinique",
        "ext": "596"
    },
    {
        "code": "MP",
        "country": "Northern Mariana Islands",
        "ext": "+1-670"
    },
    {
        "code": "MS",
        "country": "Montserrat",
        "ext": "+1-664"
    },
    {
        "code": "MR",
        "country": "Mauritania",
        "ext": "222"
    },
    {
        "code": "IM",
        "country": "Isle of Man",
        "ext": "+44-1624"
    },
    {
        "code": "UG",
        "country": "Uganda",
        "ext": "256"
    },
    {
        "code": "TZ",
        "country": "Tanzania",
        "ext": "255"
    },
    {
        "code": "MY",
        "country": "Malaysia",
        "ext": "60"
    },
    {
        "code": "MX",
        "country": "Mexico",
        "ext": "52"
    },
    {
        "code": "IL",
        "country": "Israel",
        "ext": "972"
    },
    {
        "code": "FR",
        "country": "France",
        "ext": "33"
    },
    {
        "code": "IO",
        "country": "British Indian Ocean Territory",
        "ext": "246"
    },
    {
        "code": "SH",
        "country": "Saint Helena",
        "ext": "290"
    },
    {
        "code": "FI",
        "country": "Finland",
        "ext": "358"
    },
    {
        "code": "FJ",
        "country": "Fiji",
        "ext": "679"
    },
    {
        "code": "FK",
        "country": "Falkland Islands",
        "ext": "500"
    },
    {
        "code": "FM",
        "country": "Micronesia",
        "ext": "691"
    },
    {
        "code": "FO",
        "country": "Faroe Islands",
        "ext": "298"
    },
    {
        "code": "NI",
        "country": "Nicaragua",
        "ext": "505"
    },
    {
        "code": "NL",
        "country": "Netherlands",
        "ext": "31"
    },
    {
        "code": "NO",
        "country": "Norway",
        "ext": "47"
    },
    {
        "code": "NA",
        "country": "Namibia",
        "ext": "264"
    },
    {
        "code": "VU",
        "country": "Vanuatu",
        "ext": "678"
    },
    {
        "code": "NC",
        "country": "New Caledonia",
        "ext": "687"
    },
    {
        "code": "NE",
        "country": "Niger",
        "ext": "227"
    },
    {
        "code": "NF",
        "country": "Norfolk Island",
        "ext": "672"
    },
    {
        "code": "NG",
        "country": "Nigeria",
        "ext": "234"
    },
    {
        "code": "NZ",
        "country": "New Zealand",
        "ext": "64"
    },
    {
        "code": "NP",
        "country": "Nepal",
        "ext": "977"
    },
    {
        "code": "NR",
        "country": "Nauru",
        "ext": "674"
    },
    {
        "code": "NU",
        "country": "Niue",
        "ext": "683"
    },
    {
        "code": "CK",
        "country": "Cook Islands",
        "ext": "682"
    },
    {
        "code": "XK",
        "country": "Kosovo",
        "ext": ""
    },
    {
        "code": "CI",
        "country": "Ivory Coast",
        "ext": "225"
    },
    {
        "code": "CH",
        "country": "Switzerland",
        "ext": "41"
    },
    {
        "code": "CO",
        "country": "Colombia",
        "ext": "57"
    },
    {
        "code": "CN",
        "country": "China",
        "ext": "86"
    },
    {
        "code": "CM",
        "country": "Cameroon",
        "ext": "237"
    },
    {
        "code": "CL",
        "country": "Chile",
        "ext": "56"
    },
    {
        "code": "CC",
        "country": "Cocos Islands",
        "ext": "61"
    },
    {
        "code": "CAUSA",
        "country": "Canada / United States of America",
        "ext": "1"
    },
    {
        "code": "CA",
        "country": "Canada",
        "ext": "1"
    },
    {
        "code": "US",
        "country": "United States of America",
        "ext": "1"
    },
    {
        "code": "CG",
        "country": "Republic of the Congo",
        "ext": "242"
    },
    {
        "code": "CF",
        "country": "Central African Republic",
        "ext": "236"
    },
    {
        "code": "CD",
        "country": "Democratic Republic of the Congo",
        "ext": "243"
    },
    {
        "code": "CZ",
        "country": "Czech Republic",
        "ext": "420"
    },
    {
        "code": "CY",
        "country": "Cyprus",
        "ext": "357"
    },
    {
        "code": "CX",
        "country": "Christmas Island",
        "ext": "61"
    },
    {
        "code": "CR",
        "country": "Costa Rica",
        "ext": "506"
    },
    {
        "code": "CW",
        "country": "Curacao",
        "ext": "599"
    },
    {
        "code": "CV",
        "country": "Cape Verde",
        "ext": "238"
    },
    {
        "code": "CU",
        "country": "Cuba",
        "ext": "53"
    },
    {
        "code": "SZ",
        "country": "Swaziland",
        "ext": "268"
    },
    {
        "code": "SY",
        "country": "Syria",
        "ext": "963"
    },
    {
        "code": "SX",
        "country": "Sint Maarten",
        "ext": "599"
    },
    {
        "code": "KG",
        "country": "Kyrgyzstan",
        "ext": "996"
    },
    {
        "code": "KE",
        "country": "Kenya",
        "ext": "254"
    },
    {
        "code": "SS",
        "country": "South Sudan",
        "ext": "211"
    },
    {
        "code": "SR",
        "country": "Suriname",
        "ext": "597"
    },
    {
        "code": "KI",
        "country": "Kiribati",
        "ext": "686"
    },
    {
        "code": "KH",
        "country": "Cambodia",
        "ext": "855"
    },
    {
        "code": "KN",
        "country": "Saint Kitts and Nevis",
        "ext": "+1-869"
    },
    {
        "code": "KM",
        "country": "Comoros",
        "ext": "269"
    },
    {
        "code": "ST",
        "country": "Sao Tome and Principe",
        "ext": "239"
    },
    {
        "code": "SK",
        "country": "Slovakia",
        "ext": "421"
    },
    {
        "code": "KR",
        "country": "South Korea",
        "ext": "82"
    },
    {
        "code": "SI",
        "country": "Slovenia",
        "ext": "386"
    },
    {
        "code": "KP",
        "country": "North Korea",
        "ext": "850"
    },
    {
        "code": "KW",
        "country": "Kuwait",
        "ext": "965"
    },
    {
        "code": "SN",
        "country": "Senegal",
        "ext": "221"
    },
    {
        "code": "SM",
        "country": "San Marino",
        "ext": "378"
    },
    {
        "code": "SL",
        "country": "Sierra Leone",
        "ext": "232"
    },
    {
        "code": "SC",
        "country": "Seychelles",
        "ext": "248"
    },
    {
        "code": "KZ",
        "country": "Kazakhstan",
        "ext": "7"
    },
    {
        "code": "KY",
        "country": "Cayman Islands",
        "ext": "+1-345"
    },
    {
        "code": "SG",
        "country": "Singapore",
        "ext": "65"
    },
    {
        "code": "SE",
        "country": "Sweden",
        "ext": "46"
    },
    {
        "code": "SD",
        "country": "Sudan",
        "ext": "249"
    },
    {
        "code": "DO",
        "country": "Dominican Republic",
        "ext": "+1-809 and 1-829"
    },
    {
        "code": "DM",
        "country": "Dominica",
        "ext": "+1-767"
    },
    {
        "code": "DJ",
        "country": "Djibouti",
        "ext": "253"
    },
    {
        "code": "DK",
        "country": "Denmark",
        "ext": "45"
    },
    {
        "code": "VG",
        "country": "British Virgin Islands",
        "ext": "+1-284"
    },
    {
        "code": "DE",
        "country": "Germany",
        "ext": "49"
    },
    {
        "code": "YE",
        "country": "Yemen",
        "ext": "967"
    },
    {
        "code": "DZ",
        "country": "Algeria",
        "ext": "213"
    },
    {
        "code": "UY",
        "country": "Uruguay",
        "ext": "598"
    },
    {
        "code": "YT",
        "country": "Mayotte",
        "ext": "262"
    },
    {
        "code": "UM",
        "country": "United States Minor Outlying Islands",
        "ext": "1"
    },
    {
        "code": "LB",
        "country": "Lebanon",
        "ext": "961"
    },
    {
        "code": "LC",
        "country": "Saint Lucia",
        "ext": "+1-758"
    },
    {
        "code": "LA",
        "country": "Laos",
        "ext": "856"
    },
    {
        "code": "TV",
        "country": "Tuvalu",
        "ext": "688"
    },
    {
        "code": "TW",
        "country": "Taiwan",
        "ext": "886"
    },
    {
        "code": "TT",
        "country": "Trinidad and Tobago",
        "ext": "+1-868"
    },
    {
        "code": "TR",
        "country": "Turkey",
        "ext": "90"
    },
    {
        "code": "LK",
        "country": "Sri Lanka",
        "ext": "94"
    },
    {
        "code": "LI",
        "country": "Liechtenstein",
        "ext": "423"
    },
    {
        "code": "LV",
        "country": "Latvia",
        "ext": "371"
    },
    {
        "code": "TO",
        "country": "Tonga",
        "ext": "676"
    },
    {
        "code": "LT",
        "country": "Lithuania",
        "ext": "370"
    },
    {
        "code": "LU",
        "country": "Luxembourg",
        "ext": "352"
    },
    {
        "code": "LR",
        "country": "Liberia",
        "ext": "231"
    },
    {
        "code": "LS",
        "country": "Lesotho",
        "ext": "266"
    },
    {
        "code": "TH",
        "country": "Thailand",
        "ext": "66"
    },
    {
        "code": "TF",
        "country": "French Southern Territories",
        "ext": ""
    },
    {
        "code": "TG",
        "country": "Togo",
        "ext": "228"
    },
    {
        "code": "TD",
        "country": "Chad",
        "ext": "235"
    },
    {
        "code": "TC",
        "country": "Turks and Caicos Islands",
        "ext": "+1-649"
    },
    {
        "code": "LY",
        "country": "Libya",
        "ext": "218"
    },
    {
        "code": "VA",
        "country": "Vatican",
        "ext": "379"
    },
    {
        "code": "VC",
        "country": "Saint Vincent and the Grenadines",
        "ext": "+1-784"
    },
    {
        "code": "AE",
        "country": "United Arab Emirates",
        "ext": "971"
    },
    {
        "code": "AD",
        "country": "Andorra",
        "ext": "376"
    },
    {
        "code": "AG",
        "country": "Antigua and Barbuda",
        "ext": "+1-268"
    },
    {
        "code": "AF",
        "country": "Afghanistan",
        "ext": "93"
    },
    {
        "code": "AI",
        "country": "Anguilla",
        "ext": "+1-264"
    },
    {
        "code": "VI",
        "country": "U.S. Virgin Islands",
        "ext": "+1-340"
    },
    {
        "code": "IS",
        "country": "Iceland",
        "ext": "354"
    },
    {
        "code": "IR",
        "country": "Iran",
        "ext": "98"
    },
    {
        "code": "AM",
        "country": "Armenia",
        "ext": "374"
    },
    {
        "code": "AL",
        "country": "Albania",
        "ext": "355"
    },
    {
        "code": "AO",
        "country": "Angola",
        "ext": "244"
    },
    {
        "code": "AQ",
        "country": "Antarctica",
        "ext": ""
    },
    {
        "code": "AS",
        "country": "American Samoa",
        "ext": "+1-684"
    },
    {
        "code": "AR",
        "country": "Argentina",
        "ext": "54"
    },
    {
        "code": "AU",
        "country": "Australia",
        "ext": "61"
    },
    {
        "code": "AT",
        "country": "Austria",
        "ext": "43"
    },
    {
        "code": "AW",
        "country": "Aruba",
        "ext": "297"
    },
    {
        "code": "IN",
        "country": "India",
        "ext": "91"
    },
    {
        "code": "AX",
        "country": "Aland Islands",
        "ext": "+358-18"
    },
    {
        "code": "AZ",
        "country": "Azerbaijan",
        "ext": "994"
    },
    {
        "code": "IE",
        "country": "Ireland",
        "ext": "353"
    },
    {
        "code": COUNTRY_CODE.INDONESIA,
        "country": "Indonesia",
        "ext": INDONESIA_PHONE_EXT
    },
    {
        "code": "UA",
        "country": "Ukraine",
        "ext": "380"
    },
    {
        "code": "QA",
        "country": "Qatar",
        "ext": "974"
    },
    {
        "code": "MZ",
        "country": "Mozambique",
        "ext": "258"
    },
    {
        "code": "AN",
        "country": "Netherland Antilles",
        "ext": "599"
    },
    {
        "code": "RY",
        "country": "Canary IS",
        "ext": "34"
    },
    {
        "code": "TP",
        "country": "East Timor",
        "ext": "0"
    },
    {
        "code": "XZ",
        "country": "Kosovo",
        "ext": "381"
    },
    {
        "code": "XE",
        "country": "St. Eustatius",
        "ext": "599"
    },
    {
        "code": "XB",
        "country": "Bonaire",
        "ext": "599-7"
    }
  ];